import type { GQL_ID } from '@@partner:types:graphql'
import type { Category, RsuiteItemDataType } from '@@partner:types:app'

import React, { useState, useEffect, useCallback } from 'react'
import { useFetchQuery } from '@@partner:graphql/query/catalog/productAvailableBrands.gql'

import { CheckPicker } from 'rsuite'
import { useDebounce } from 'use-debounce'
export interface ProductBrandsFilterrProps {
  skipIds?: GQL_ID[]
  value: GQL_ID[]
  onChange: (value: GQL_ID[]) => void
  multiple?: boolean
}

const mapToItemDataType = (category: Category) => ({
  label: category.name,
  value: category.id,
  children: [],
  loading: false,
  parent_id: category.parent_id,
  __category: category
})

export default function ProductBrandsFilter ({
  skipIds = [],
  value,
  onChange,
  multiple = true
}: ProductBrandsFilterrProps) {
  
  const [ searchName, setSearchName ] = useState('')
  const [ debouncedSearchName ] = useDebounce(searchName, 1000)

  const { data: brandsData, loading, error } = useFetchQuery({ name: debouncedSearchName })

  const preparedData: RsuiteItemDataType[] = brandsData?.brands.map(brand => ({
    label: brand.name,
    value: brand.id
  })) ?? []

  const handleSearchNameChange = useCallback((value: string) => {
    setSearchName(value)
  }, [])


  const handleChange = (value: GQL_ID[]) => {
    onChange(value)
  }

  const handleClear = () => {
    onChange([])
  }

  return (
    <div>
      {/* {JSON.stringify(data)} */}
      <CheckPicker
        block
        searchable={true}
        data={preparedData}
        value={value}
        onClean={handleClear}
        onSelect={handleChange}
        onSearch={handleSearchNameChange}
        placeholder='Бренды'
      />
    </div>
  )
}
